import { CS } from "../../../../base/utils/styler";

export const checkTdStyle: CS = {
  width: '30px', paddingRight: '10px'
}
export const checkTdInputStyle: CS = {
  cursor: 'pointer',
  width: '20px',
  height: '20px',
  border: '1px solid #bbb',
  borderRadius: '5px',
  '&:hover': {
    borderColor: '#999',
  },
  '&:checked': {
    backgroundColor: '#007bff', // Example: Change background when checked
    borderColor: 'white',
    borderWidth: '4px',
    boxShadow: '0 0 0 1px #bbb',
    width: '18px',
    height: '18px',
    borderRadius: '4px',
  },
  '&:disabled': {
    borderColor: '#eee',
  },

}

/* 
Todo: try
  // When it’s checked, change background/border color, etc.
  '&:checked': {
    borderColor: '#007bff',
    backgroundColor: '#007bff',
    position: 'relative', // so that ::after can be positioned
  },

  // Show the check symbol (✓) when checked
  '&:checked::after': {
    content: '"\\2713"', // or "✓"
    color: '#fff',
    position: 'absolute',
    left: '4px',
    top: '0px',
    fontSize: '18px',
    lineHeight: '20px',
  },

*/